import _ from 'lodash';
import { createWebHistory, createRouter } from 'vue-router';
import AppLayout from '@/AppLayout.vue';
import { generalStore } from '@/store';

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/LoginLayout.vue'),
        meta: {
            title: 'YSLP - Login',
            name: 'Login',
            AllowAnonymous: true,
        },
    },
    {
        name: 'form',
        path: '/form/:id',
        component: () => import('@/components/IframeForm.vue'),
        props: (route: any): unknown => {
            return {
                params: route.query.parametrs,
                id: route.params.id,
                styles: route.query.styles,
            };
        },
        meta: {
            AllowAnonymous: true,
        },
    },
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', redirect: '/home' },
            {
                path: '/home',
                name: 'home',
                component: () => import('@/pages/HomePage.vue'),
                meta: {
                    title: 'AutoProc - Home',
                    //padding: '25px',
                },
            },
            {
                path: '/manage',
                name: 'manage',
                component: () => import('@/components/Manage.vue'),
                meta: {
                    title: 'YSLP - Manage',
                },
            },
            {
                path: '/data-structures',
                name: 'data-structures',
                component: () => import('@/components/DataStructures.vue'),
                meta: {
                    title: 'YSLP - Data Structures',
                },
            },
            {
                path: '/dashboard',
                name: 'dashboards',
                component: () => import('@/components/Dashboards.vue'),
                meta: {
                    title: 'YSLP - Dashboards',
                },
            },
            {
                path: '/page-template/:id',
                name: 'page-template',
                component: () => import('@/components/PageTemplate.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Page Template',
                    isPage: true,
                },
            },
            {
                path: '/page-settings/:id',
                name: 'page-settings',
                component: () => import('@/components/PageSettings.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Page Settings',
                    isPage: true,
                },
            },
            {
                path: '/page-form/:id',
                name: 'page-form',
                component: () => import('@/components/PageForm.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Page Form',
                    isPage: true,
                },
            },
            {
                path: '/page-publish/:id',
                name: 'page-publish',
                component: () => import('@/components/PagePublish.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Page Deploy',
                    isPage: true,
                },
            },
            {
                path: '/page-submissions/:id/:type?',
                name: 'page-submissions',
                component: () => import('@/components/PageSubmissions.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Page Submissions',
                    isPage: true,
                },
            },
            {
                path: '/accessibility-declaration',
                name: 'accessibility-declaration',
                component: () => import('@/components/AccessibilityDeclaration.vue'),
                meta: {
                    title: 'YSLP - Accessibility Declaration',
                },
            },
            {
                path: '/newsletter-template/:id',
                name: 'newsletter-template',
                component: () => import('@/components/NewsletterTemplate.vue'),
                props: true,
                meta: {
                    title: 'YSLP - Newsletter Template',
                },
            },
            {
                path: '/new-project/:id?',
                name: 'new-project',
                component: () => import('@/components/NewProject.vue'),
                props: true,
                meta: {
                    title: 'YSLP - New project',
                },
            },
            // New pages created as AutoProc
            {
                path: '/sms-list/:selectedTab?',
                name: 'sms-list',
                props: true,
                component: () => import('@/pages/SMSListPage.vue'),
                meta: {
                    title: 'AutoProc - SMS',
                    padding: '25px',
                },
            },
            {
                path: '/emails-list/:selectedTab?/:type?',
                name: 'emails-list',
                props: true,
                component: () => import('@/pages/EmailsListPage.vue'),
                meta: {
                    title: 'AutoProc - Emails',
                    padding: '25px',
                },
            },
            {
                path: '/send-email/:id?',
                name: 'send-email',
                props: true,
                component: () => import('@/pages/EmailSendPage.vue'),
                meta: {
                    title: 'AutoProc - Send Email',
                    padding: '25px',
                },
            },
            {
                path: '/send-sms/:id?',
                name: 'send-sms',
                props: true,
                component: () => import('@/pages/SMSSendPage.vue'),
                meta: {
                    title: 'AutoProc - Send SMS',
                    padding: '25px',
                },
            },

            {
                path: '/contacts/:selectedTab?',
                name: 'contacts',
                component: () => import('@/pages/ContactsPage.vue'),
                props: true,
                meta: {
                    title: 'AutoProc - Contacts',
                    padding: '25px',
                },
            },

            {
                path: '/contact-card/:id',
                name: 'contact-card',
                component: () => import('@/pages/ContactCardPage.vue'),
                props: true,
                meta: {
                    title: 'AutoProc - ContactDetails',
                    padding: '25px',
                },
            },
            {
                path: '/contacts/import',
                name: 'contacts-import',
                component: () => import('@/pages/ContactsImport.vue'),
                meta: {
                    title: 'AutoProc - ContactsImport',
                    padding: '25px',
                },
            },
            {
                path: '/automations',
                name: 'automations',
                component: () => import('@/pages/AutomationsPage.vue'),
                meta: {
                    title: 'AutoProc - Automations',
                    padding: '25px',
                },
            },
            {
                path: '/automations/:id',
                name: 'exact-automation',
                component: () => import('@/pages/AutomationPage.vue'),
                meta: {
                    title: 'AutoProc - Automations',
                    padding: '25px',
                },
            },
            {
                path: '/landing-pages',
                name: 'landing-pages',
                component: () => import('@/pages/LandingPagesPage.vue'),
                meta: {
                    title: 'AutoProc - Landing Pages',
                    padding: '25px',
                },
            },
            {
                path: '/settings/:selectedTab?',
                name: 'settings',
                props: true,
                component: () => import('@/pages/ClientSettings.vue'),
                meta: {
                    title: 'AutoProc - Settings',
                    padding: '25px',
                },
            },
        ],
    },
];
//if (Vue.config.devtools) {
if (true) {
    const samplePage = {
        path: '/style-sample-page',
        name: 'style-sample-page',
        component: () => import('@/pages/StyleSamplePage.vue'),
        meta: {
            title: 'YSLP - Sample Typograpy page',
            padding: '25px',
        },
    };
    routes.find((x) => !x.path)?.children?.push(samplePage as any);
}

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = generalStore.state.IsAuthenticated;
    document.title = (to.meta.title as string) || 'YSLP';

    generalStore.state.CurrentRouteName = (to.name as string) || '';
    if (to.params?.id && to.meta?.isPage) generalStore.state.CurrentPageId = to.params.id as string;

    if (!to.meta!.AllowAnonymous && to.name !== 'login' && !isAuthenticated) {
        console.log(_.cloneDeep(to));
        next({
            name: 'login',
            query: { returnUrl: to.path },
        });
    } else if (isAuthenticated && to.name === 'login') {
        if (to.query?.returnUrl) {
            next({
                path: to.query?.returnUrl.toString(),
            });
        } else
            next({
                name: 'home',
            });
    } else next();
});

export default router;
